/*! ******************************************************************************************************** *
 *
 * Copyright 2011-2020 Markus Schütz
 * Copyright 2025 Oidis
 *
 * SPDX-License-Identifier: BSD-2-Clause
 * The BSD-2-Clause license for this file can be found in the LICENSE.txt file included with this distribution
 * or at https://spdx.org/licenses/BSD-2-Clause.html#licenseText
 *
 * ********************************************************************************************************* */

export class Version {
    constructor(version) {
        this.version = version;
        let vmLength = (version.indexOf(".") === -1) ? version.length : version.indexOf(".");
        this.versionMajor = parseInt(version.substr(0, vmLength));
        this.versionMinor = parseInt(version.substr(vmLength + 1));
        if (this.versionMinor.length === 0) {
            this.versionMinor = 0;
        }
    }

    newerThan(version) {
        let v = new Version(version);

        if (this.versionMajor > v.versionMajor) {
            return true;
        } else if (this.versionMajor === v.versionMajor && this.versionMinor > v.versionMinor) {
            return true;
        } else {
            return false;
        }
    }

    equalOrHigher(version) {
        let v = new Version(version);

        if (this.versionMajor > v.versionMajor) {
            return true;
        } else if (this.versionMajor === v.versionMajor && this.versionMinor >= v.versionMinor) {
            return true;
        } else {
            return false;
        }
    }

    upTo(version) {
        return !this.newerThan(version);
    }
}
